import { DotLegalDialog, DotLegalHeader, DotLegalTable } from "@dotlegal/dotlegal-ui-components";
import { Box, LinearProgress, TableRow } from "@mui/material";
import { useTranslation } from "@localization/useTranslation";
import { SelectableAssignee } from "../../SelectableAssignee.types";
import { getSelectableAssigneeHeaders, SelectableAssigneeCells } from "../../selectableAssigneeTable/SelectableAssigneeColumns";
import useSendAssessmentsDialog from "./SendAssessmentsDialog.hooks";

export interface ISendAssessmentsDialogProps {
    internalAssessmentGroupId: string;
    internalAssessmentGroupName: string;
    selectedAssignees: Array<SelectableAssignee>;
    onDialogClose: () => void;
}

function SendAssessmentsDialog(props: ISendAssessmentsDialogProps) {
    const { translateString } = useTranslation();
    const { send, isSending, failed, sentCount, numberOfRecipients, progress } = useSendAssessmentsDialog(props);

    return (
        <DotLegalDialog
            size="lg"
            open
            inProgress={isSending}
            header={translateString("sendAssessments")}
            buttonOkText={translateString("send")}
            onDialogClose={props.onDialogClose}
            onOkClick={send}
        >
            <DotLegalTable
                headers={getSelectableAssigneeHeaders(translateString)}
                defaultOrderBy={"name"}
                defaultOrder={"asc"}
                isLoading={false}
                data={props.selectedAssignees}
                emptyText={translateString("noData")}
                paginationLabelOf={translateString("labelOf")}
                renderRow={(row) => (
                    <TableRow key={`${row.assigneeType}-${row.id}`}>
                        <SelectableAssigneeCells row={row} translateString={translateString} />
                    </TableRow>
                )}
            />

            {(isSending || failed) && (
                <Box sx={{ mt: 2 }}>
                    <DotLegalHeader headerStyle={"small"} center>
                        {translateString("sendingXOfY", { current: sentCount, total: numberOfRecipients })}
                    </DotLegalHeader>
                    <LinearProgress sx={{ height: 10, borderRadius: 5 }} variant="determinate" value={progress} />
                </Box>
            )}
        </DotLegalDialog>
    );
}

export default SendAssessmentsDialog;
